import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const items = [{
    title: 'Acompañamiento en español',
    desc: 'Te explicamos cada paso de forma simple, clara y humana.',
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5a4579" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-17">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" data-id="element-18" />
        </svg>
  }, {
    title: 'Proceso más ordenado',
    desc: 'Sabes qué sigue y qué necesitas en cada etapa.',
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5a4579" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-19">
          <line x1="8" y1="6" x2="21" y2="6" data-id="element-20" />
          <line x1="8" y1="12" x2="21" y2="12" data-id="element-21" />
          <line x1="8" y1="18" x2="21" y2="18" data-id="element-22" />
          <polyline points="3 6 4 7 6 5" data-id="element-23" />
          <polyline points="3 12 4 13 6 11" data-id="element-24" />
          <polyline points="3 18 4 19 6 17" data-id="element-25" />
        </svg>
  }, {
    title: 'Base profesional para avanzar',
    desc: 'Empresa y presencia digital listas desde el inicio.',
    icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#5a4579" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-26">
          <circle cx="12" cy="8" r="6" data-id="element-27" />
          <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" data-id="element-28" />
        </svg>
  }];
  return <section className="about-section" style={{
    background: '#FFFFFF',
    padding: '60px 20px',
    marginTop: 0,
    marginBottom: 0
  }} data-id="element-29">
      <style data-id="element-30">{`
        @media (min-width: 769px) {
          .about-section { padding: 60px 40px !important; }
        }
        @keyframes inkova-pulse-dot {
          0% { box-shadow: 0 0 0 0 rgba(37,211,102,0.4); }
          70% { box-shadow: 0 0 0 8px rgba(37,211,102,0); }
          100% { box-shadow: 0 0 0 0 rgba(37,211,102,0); }
        }
      `}</style>

      <div className="max-w-6xl mx-auto" data-id="element-31">
        <div className="grid md:grid-cols-2 gap-8 md:gap-[60px] items-center" data-id="element-32">
          {/* LEFT — Photo (premium treatment) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative w-full mb-7 md:mb-0" data-id="element-33">
            {/* Photo container */}
            <div className="relative w-full overflow-hidden about-photo-wrap" style={{
            borderRadius: '20px',
            background: 'linear-gradient(135deg, #4a3666, #5a4579)',
            boxShadow: '0 16px 48px rgba(90,69,121,0.15)',
            zIndex: 1
          }} data-id="element-34">
              <style data-id="element-35">{`
                .about-photo-wrap { height: 320px; }
                @media (min-width: 769px) {
                  .about-photo-wrap {
                    height: 480px !important;
                  }
                }
              `}</style>

              <img src="https://cdn.magicpatterns.com/uploads/vA47NCyeUWMzn2W6Tr1Xk7/WhatsApp_Image_2026-05-08_at_10.13.00_AM.jpg" alt="Annysol Navarro — Fundadora de Inkova" className="w-full h-full block" style={{
              objectFit: 'cover',
              objectPosition: 'center top'
            }} data-id="element-36" />

              {/* Gradient overlay at the bottom */}
              <div className="absolute pointer-events-none" style={{
              bottom: 0,
              left: 0,
              right: 0,
              height: '40%',
              background: 'linear-gradient(to top, rgba(90,69,121,0.6) 0%, transparent 100%)'
            }} aria-hidden="true" data-id="element-37" />

              {/* Floating badge */}
              <div className="flex items-center about-badge" style={{
              position: 'absolute',
              bottom: '16px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: '#FFFFFF',
              border: '1px solid rgba(90,69,121,0.15)',
              boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
              borderRadius: '50px',
              padding: '7px 16px',
              gap: '8px',
              whiteSpace: 'nowrap'
            }} data-id="element-38">
                <span style={{
                width: '8px',
                height: '8px',
                minWidth: '8px',
                background: '#25D366',
                borderRadius: '50%',
                boxShadow: '0 0 0 0 rgba(37,211,102,0.4)',
                animation: 'inkova-pulse-dot 2s infinite',
                display: 'inline-block'
              }} data-id="element-39" />
                <span style={{
                fontSize: '11px',
                fontWeight: 600,
                color: '#2D1B4E',
                letterSpacing: '0.3px'
              }} data-id="element-40">
                  Annysol Navarro · Fundadora
                </span>
              </div>
              <style data-id="element-41">{`
                @media (min-width: 769px) {
                  .about-badge {
                    bottom: 20px !important;
                    padding: 8px 20px !important;
                  }
                  .about-badge span:last-child {
                    font-size: 12px !important;
                  }
                }
              `}</style>
            </div>
          </motion.div>

          {/* RIGHT — Text + items */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-42">
            <p style={{
            color: '#5a4579',
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            marginBottom: '8px'
          }} data-id="element-43">
              Quién te acompaña
            </p>
            <h2 className="text-[24px] md:text-[34px]" style={{
            fontWeight: 800,
            color: '#2D1B4E',
            lineHeight: 1.2,
            marginBottom: '16px'
          }} data-id="element-44">
              Más claridad. Más{' '}
              <span className="italic" style={{
              color: '#5a4579'
            }} data-id="element-45">
                acompañamiento
              </span>
              . Menos improvisación.
            </h2>
            <p className="text-[14px] md:text-[15px]" style={{
            color: '#6B7280',
            lineHeight: 1.7,
            marginBottom: '28px'
          }} data-id="element-46">
              Soy Annysol, fundadora de Inkova. Trabajo con emprendedores
              latinos que quieren crear su empresa en EE. UU. con estructura,
              claridad y apoyo real en español desde el inicio.
            </p>

            {/* Items */}
            <div className="flex flex-col gap-3 md:gap-4" data-id="element-47">
              {items.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + i * 0.08
            }} className="flex items-start" style={{
              gap: '14px'
            }} data-id="element-48">
                  <div className="flex items-center justify-center flex-shrink-0" style={{
                width: '40px',
                height: '40px',
                minWidth: '40px',
                background: 'linear-gradient(135deg, rgba(90,69,121,0.08), rgba(90,69,121,0.04))',
                border: '1px solid rgba(90,69,121,0.1)',
                borderRadius: '10px'
              }} data-id="element-49">
                    {item.icon}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-50">
                    <div style={{
                  fontSize: '14px',
                  fontWeight: 700,
                  color: '#2D1B4E',
                  marginBottom: '2px'
                }} data-id="element-51">
                      {item.title}
                    </div>
                    <div style={{
                  fontSize: '13px',
                  color: '#6B7280',
                  lineHeight: 1.5
                }} data-id="element-52">
                      {item.desc}
                    </div>
                  </div>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}